import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    active: 'aside'
  },
  mutations: {
    switchHome (state, active) {
      state.active = active;
    }
  }
});